import axios from "axios";
import toast from "react-hot-toast";
import mainAxios from "../redux/api/mainAxios";

const handlePasswordReset = async (token, newPassword, confirmMdp) => {
  try {
    const response = await mainAxios.post(`api/auth/reset-password`, {
      password: newPassword,
      passwordConfirmation: confirmMdp,
      code: token,
    });

    if (response.status === 200) {
      toast.success("Mot de passe changé avec succès");
      return true;
    } else {
      toast.error("Erreur lors du changement de mot de passe");
      return false;
    }
  } catch (error) {
    console.error(
      "Request failed:",
      error.response ? error.response.data : error.message
    );
    toast.error("Erreur serveur, veuillez réessayer plus tard");
    return false;
  }
};

export default handlePasswordReset;
